<div class="login-card">
  <img class="logo" src="assets/images/carelflex-logo.png" alt="Carelflex"/>
  <h1 class="title">Mission Configurator</h1>
  <p class="subtitle">Sign in with your Arkema account to configure the missions.</p>
  <df-button variant="primary" size="lg" block (onClick)="login()">Sign in</df-button>
  @if (infoMessage) {
    <p class="error">{{ infoMessage }}</p>
  }
</div>
